import { TribeMembershipDetails } from 'src/api/circles';
import { FileMediaLinks, Pagination } from 'src/api/common';
import { Post } from 'src/api/posts';
import api from './baseApi';
import { ChallengeEngagementMetrics } from './engagements';

export interface User {
  _id: string;
  createdAt: string;
  updatedAt: string;

  phone_number: string;
  full_name?: string;
  email?: string;

  avatar_id?: string;
  avatar_url?: string;
  avatar?: FileMediaLinks;

  bio?: string;
  last_login_date?: string;
  blocked_users?: string[];
  role?: string;
  devices?: Device[];
}

export interface Device {
  device_token: string;
  manufacturer_id: string;
  arn: string;
}

export interface UserWithTribeMembershipDetails {
  result: User;
  tribe_details: TribeMembershipDetails[];
  comment_count: number;
  like_count: number;
}

interface UploadFileParams {
  contentType: string;
  name?: string;
  type?: string;
}

interface UpdateUserRequest {
  full_name?: string;
  avatar_id?: string;
  bio?: string;
  email?: string;
}

interface UploadFileResponse {
  uploadURL: string;
  key: string;
  file_id: string;
}

export type PostWithEngagementMetrics = Post & {
  engagement: ChallengeEngagementMetrics;
};
interface FeedResponse {
  result: PostWithEngagementMetrics[];
  pagination: Pagination;
}

export const usersApi = {
  userMe: async (): Promise<UserWithTribeMembershipDetails> => {
    const axiosResponse = await api.get(`users/me`);
    return axiosResponse.data;
  },

  getUserById: async (
    userId: string
  ): Promise<UserWithTribeMembershipDetails> => {
    const axiosResponse = await api.get(`users/${userId}`);
    return axiosResponse.data.result;
  },

  updateById: async (
    userId: string,
    updatedUser: UpdateUserRequest
  ): Promise<User> => {
    const axiosResponse = await api.patch(`users/${userId}`, updatedUser);
    return axiosResponse.data.result;
  },

  uploadFile: async (params: UploadFileParams): Promise<UploadFileResponse> => {
    const axiosResponse = await api.post(`files/uploader`, params);
    return axiosResponse.data;
  },

  getFeed: async (params?: {
    page?: number;
    pageSize?: number;
  }): Promise<FeedResponse> => {
    const { page, pageSize } = params ?? {};
    const queryParams = new URLSearchParams();
    if (page) {
      queryParams.append('page', page.toString());
    }
    if (pageSize) {
      queryParams.append('pageSize', pageSize.toString());
    }

    const axiosResponse = await api.get(`users/feed?${queryParams.toString()}`);
    return axiosResponse.data;
  },
};
